const o = "Campo color, el color actual es {color}", r = "Color field", l = "Colors palette", e = "Colores predefinidos", c = "Custom preset colors", s = "Add color", t = "Borar color", a = "Custom color, HEX format", C = "Añadir color a la lista de colores personalizados", d = "Borrar campo de color personalizado", n = "Delete color with backspace", i = {
  currentColor: o,
  emptyColor: r,
  palette: l,
  presetColors: e,
  customColors: c,
  addColor: s,
  clearColor: t,
  colorField: a,
  colorFieldConfirm: C,
  colorFieldClear: d,
  deleteColorDescriber: n
};
export {
  s as addColor,
  t as clearColor,
  a as colorField,
  d as colorFieldClear,
  C as colorFieldConfirm,
  o as currentColor,
  c as customColors,
  i as default,
  n as deleteColorDescriber,
  r as emptyColor,
  l as palette,
  e as presetColors
};
